// Central pricing + FX configuration for Dentel Vietnam.
// VND is the SOURCE OF TRUTH. USD/AUD are approximate convenience conversions.
// Change the reference rates here once — every page updates automatically.
// NOTE: figures are indicative examples from a selected Dentel Vietnam partner
// provider. The provider's identity is intentionally not exposed.

export const FX = {
  // 1 unit of currency ≈ N VND
  USD_PER_VND: 26335, // 1 USD ≈ 26,335 VND
  AUD_PER_VND: 18350, // 1 AUD ≈ 18,350 VND
  referenceUpdated: "July 2026",
};

export const formatVND = (vnd) => `${vnd.toLocaleString("en-US")} VND`;
export const toUSD = (vnd) => `$${Math.round(vnd / FX.USD_PER_VND).toLocaleString("en-US")}`;
export const toAUD = (vnd) => `$${Math.round(vnd / FX.AUD_PER_VND).toLocaleString("en-US")}`;

// Indicative implant pricing (per implant unless noted).
export const IMPLANT_PRICES = [
  { name: "Ken Implant", vnd: 11006358 },
  { name: "Biotem", vnd: 14008092 },
  { name: "Hiossen", vnd: 20011560 },
  { name: "Dentium SuperLine", vnd: 24988119 },
  { name: "NTA", vnd: 26989275 },
  { name: "Neodent", vnd: 34967568 },
  { name: "Straumann", vnd: 44946817 },
];

export const IMPLANT_EXTRAS = [
  { name: "Bone Graft (1 cc)", vnd: 6977715, clinicalNote: true },
];

// Indicative crown pricing (per tooth).
export const CROWN_PRICES = [
  { name: "Zirconia", vnd: 3200000 },
  { name: "Katana", vnd: 3950000 },
  { name: "Zirconia HT", vnd: 4200000 },
  { name: "Upcera", vnd: 4200000 },
  { name: "Venus", vnd: 6200000 },
  { name: "Ceramill Zolid", vnd: 6400000 },
  { name: "Cercon HT", vnd: 6200000 },
  { name: "Diamond", vnd: 7200000 },
  { name: "Lava Plus", vnd: 8200000 },
  { name: "Diamond Plus", vnd: 9000000 },
  { name: "Lava Esthetic", vnd: 9000000 },
  { name: "Orodent", vnd: 15000000 },
  { name: "Diamond Esthetic", vnd: 15000000 },
];

// Indicative veneer pricing (per tooth).
export const VENEER_PRICES = [
  { name: "Ceramill Veneer", vnd: 6500000 },
  { name: "E.max Veneer", vnd: 8500000 },
  { name: "Lisi Veneer", vnd: 9500000 },
  { name: "Diamond Veneer", vnd: 15500000 },
];

// Placeholder structure for future confirmed package/combo pricing.
export const PACKAGE_PRICES = []; // e.g. { name, units, vnd, conditions, validUntil }
